import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from 'react';

import { Box, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tabs from '@material-ui/core/Tabs';
import Tooltip from '@material-ui/core/Tooltip';
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { getListAllAPI, getListAPI } from '../../../services';
import {
  STATUS_ATIVO,
  STATUS_INATIVO,
  SECONDARY_COLOR,
  formatDateDDMMYYYYHHmm,
} from '../../../utils';
import ContainerDialogoProduto from '../ContainerDialogoProduto';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: SECONDARY_COLOR,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  pendente: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: 'white',
    backgroundColor: '#f44336',
    cursor: 'pointer',
  },
  confirmado: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: 'white',
    backgroundColor: '#4caf50',
    cursor: 'pointer',
  },
  backdrop: {
    zIndex: 10000,
    color: '#fff',
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'black',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const DEFAULT_ID = -1;

const perPage = 10;

const DialogoShowProduto = forwardRef(({ handleClose = () => {} }, ref) => {
  const [open, setOpen] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [id, setId] = useState(DEFAULT_ID);
  const [dados, setDados] = useState({
    descricao: '',
    data: '',
    status: '',
  });
  const [itens, setItens] = useState([]);

  const [carregando, setCarregando] = useState(false);
  const [page, setPage] = useState(0);
  const [value, setValue] = React.useState(0);

  const [total, setTotal] = useState(0);
  const [cont, setCont] = useState(0);

  const refContainerDialogoProduto = useRef(null);

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  function formatDadosConferencia(dados) {
    const dadosFormatados = {};

    dadosFormatados.nome = dados.nome;
    dadosFormatados.data = moment(new Date(dados.data)).format(
      'DD/MM/YYYY - HH:mm',
    );

    return dadosFormatados;
  }

  function formatItens(itens) {
    const dadosFormatados = [];

    if (itens) {
      if (itens.length > 0) {
        for (let i = 0; i < itens.length; i++) {
          dadosFormatados.push({
            status: itens[i].status,
            id: itens[i].id,
            produto: itens[i].nome,
            conferente: itens[i].username,
            data: formatDateDDMMYYYYHHmm(itens[i].data),
          });
        }
      }
    }

    return dadosFormatados;
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'conferencia_propriedade_produtos',
        ['id', 'asc'],
        { id: [id] },
        [],
      );

      if (data.data.length > 0) {
        setId(data.data[0].id);
        setDados(formatDadosConferencia(data.data[0]));
        setPage(0);
        setCarregando(false);
        setCont(cont + 1);
      } else {
        throw 'Esta Conferência não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog(-1);
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setOpen(true);
      setCarregando(true);
      getDataResource(id);
    },
  }));

  async function getItens(page) {
    setCarregando(true);
    const response = await getListAPI(
      'conferencia_propriedade_produtos_itens',
      ['id', 'asc'],
      [page + 1, perPage],
      {
        conferencia_burra_propriedade_produto_id: id,
        status: value === 0 ? STATUS_ATIVO : STATUS_INATIVO,
      },
      [],
    );
    setTotal(response.total);
    setItens(formatItens(response.data));
    setCarregando(false);
  }

  useEffect(() => {
    getItens(page);
  }, [page, value, cont]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  function handleConferir(id) {
    if (refContainerDialogoProduto.current) {
      refContainerDialogoProduto.current.handleEdit(id);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(0);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        fullScreen
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
        >{`Conferência de Produto: ${dados.nome}`}</DialogTitle>
        <DialogContent dividers>
          <div style={{ height: '100%' }}>
            <Box
              display={{ xs: 'block', sm: 'flex' }}
              flexDirection="column"
              marginBottom="30px"
              height="100%"
            >
              {carregando ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '300px',
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <Box p="1em">
                  <Box flex={2} mr="1em">
                    <Box
                      display="flex"
                      alignItems="center"
                      mt="20px"
                      fontSize={20}
                    >
                      <Box flex={1}>
                        <span
                          style={{
                            marginRight: '10px',
                            fontWeight: 'bold',
                          }}
                        >
                          Descrição:
                        </span>
                        {dados.nome}
                      </Box>
                      <Box flex={1}>
                        <span
                          style={{
                            marginRight: '10px',
                            fontWeight: 'bold',
                          }}
                        >
                          Data Criação:
                        </span>
                        {dados.data}
                      </Box>
                    </Box>
                  </Box>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '50px 0 20px',
                    }}
                  >
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons="auto"
                    >
                      <Tab label="Pendentes" {...a11yProps(0)} />
                      <Tab label="Conferido" {...a11yProps(1)} />
                    </Tabs>
                  </div>
                  <Box display="flex">
                    <Box flex={2} mr="1em">
                      <TabPanel value={value} index={0}>
                        <Box mt="1em" />
                        <Divider />
                        <Box mt="1em" />

                        <Box mt="1em" />
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.table}
                            aria-label="customized table"
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell>Status</StyledTableCell>
                                <StyledTableCell>Id</StyledTableCell>
                                <StyledTableCell>Produto</StyledTableCell>
                                <StyledTableCell>Ações</StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {itens.map((row) => (
                                <StyledTableRow key={row.id}>
                                  <StyledTableCell>
                                    <Avatar className={classes.pendente}>
                                      <PriorityHighIcon
                                        style={{ fontSize: 15 }}
                                      />
                                    </Avatar>
                                  </StyledTableCell>
                                  <StyledTableCell>{row.id}</StyledTableCell>
                                  <StyledTableCell>
                                    {row.produto}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <Tooltip
                                      title="Conferir"
                                      placement="bottom"
                                      aria-label="add2"
                                    >
                                      <IconButton
                                        aria-label="conferir"
                                        size="small"
                                        onClick={() => handleConferir(row.id)}
                                      >
                                        <CheckCircleOutlineIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[perPage]}
                            count={total}
                            rowsPerPage={perPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={() => {}}
                            labelRowsPerPage="Por página"
                            labelDisplayedRows={({ from, to, count }) =>
                              `${from}-${to} de ${
                                count !== -1 ? count : `more than ${to}`
                              }`
                            }
                          />
                        </TableContainer>
                        <Box mt="1em" />
                        <Divider />
                        <Box mt="1em" />
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <Box mt="1em" />
                        <Divider />
                        <Box mt="1em" />

                        <Box mt="1em" />
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.table}
                            aria-label="customized table"
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell>Status</StyledTableCell>
                                <StyledTableCell>Id</StyledTableCell>
                                <StyledTableCell>Produto</StyledTableCell>
                                <StyledTableCell>Conferente</StyledTableCell>
                                <StyledTableCell>
                                  Data Conferencia
                                </StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {itens.map((row) => (
                                <StyledTableRow key={row.id}>
                                  <StyledTableCell>
                                    <Avatar className={classes.confirmado}>
                                      <CheckIcon style={{ fontSize: 15 }} />
                                    </Avatar>
                                  </StyledTableCell>
                                  <StyledTableCell>{row.id}</StyledTableCell>
                                  <StyledTableCell>
                                    {row.produto}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {row.conferente}
                                  </StyledTableCell>
                                  <StyledTableCell>{row.data}</StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[perPage]}
                            count={total}
                            rowsPerPage={perPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={() => {}}
                            labelRowsPerPage="Por página"
                            labelDisplayedRows={({ from, to, count }) =>
                              `${from}-${to} de ${
                                count !== -1 ? count : `more than ${to}`
                              }`
                            }
                          />
                        </TableContainer>
                        <Box mt="1em" />
                        <Divider />
                        <Box mt="1em" />
                      </TabPanel>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </div>
        </DialogContent>
        <Backdrop
          className={classes.backdrop}
          open={carregando}
          onClick={() => {}}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <ContainerDialogoProduto
        ref={refContainerDialogoProduto}
        handleClose={() => getItens(page)}
        conferencia_burra_propriedade_produto_id={id}
      />
    </>
  );
});

export default DialogoShowProduto;
